export const SET_COLLECTIONS_BYID = 'folders/collections/SET_COLLECTIONS_BYID'
export const OPEN_COLLECTION = 'folders/collections/OPEN_COLLECTION'
export const BUILD_FROM_WIDGETS = 'folders/BUILD_FROM_WIDGETS'
